// extracted by mini-css-extract-plugin
export default {"item":"BuildsItem__item__EFjrH"};